import React from "react";
import { Flex, Icon, Text } from "@chakra-ui/react";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { c } from "./classroomColors";

const TeacherClassroomsTile = ({ label = "Created Spaces" }) => {
  return (
    <Flex alignItems="center" gap="8px">
      <Icon as={HiOutlineUserGroup} boxSize={5} color={c.text} />
      <Text
        color={c.text}
        fontSize="20px"
        fontWeight="500"
      >
        {label}
      </Text>
    </Flex>
  );
};

export default TeacherClassroomsTile;
